import React, { useEffect, useRef, useState } from 'react';
import { Box, List, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import configAPI from '../../api/config';
import { loginSuccess } from '../../features/auth/authSlice';
import { useAuth } from '../../hooks/useAuth';
import { Roles } from '../../constants/params/constants';
import { setAcademicYearList } from '../../features/academicYear/academicYearListSlice';
import { GetAllAcademicYearList } from '../../api/SchoolService/SchoolService';
import { getSchoolProfileSuccess } from '../../features/schoolProfile/schoolProfileSlice';
import { setAcademicYear } from '../../features/academicYear/academicYearSlice';
import { setSelectedSchool } from '../../features/schoolProfile/selectedSchoolSlice';
import { ROUTES } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
import schoolProfileLogo from '../../assets/images/schoolProfileLogo.png';

const AllSchoolnameDropdown = () => {
  const theme = useTheme();
const { user } = useAuth();
const navigate = useNavigate();
const dropdownRef = useRef(null);
const dispatch = useDispatch();
const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
const { schoolProfileData } = useSelector(state => state.schoolProfile);
const selectedSchool = useSelector(state => state.selectedSchool.selectedSchool);
const ActiveAcademicYears = useSelector((state) => state.academicYear.academicYear);
const [isLoading, setIsLoading] = useState(false);

const schoolList = user?.schoolList ?? [];

  const getFullImageUrl = path => {
    if (!path) return null;
    if (path.startsWith('http') || path.startsWith('https')) return path;
    return `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}${path}`;
  };

const [schoolDropList, setSchoolDropList] = useState([]);
const [selectedOption, setSelectedOption] = useState(null);
const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    if (
      schoolList.length > 1 &&
      (
        user?.roleName === Roles[5].RoleName ||
        user?.roleName === Roles[6].RoleName ||
        user?.roleName === Roles[0].RoleName
      )
    ) {
      setIsOpen(prev => !prev);
    }
  };

 const fetchAcademicYearList = async (schoolID, option) => {
        try {
          if(isLoading){
            return;
          }
          setIsLoading(true);
          const formData = new FormData();
          formData.append("SchoolID", schoolID)
          
          const res = await GetAllAcademicYearList(formData);
          if(res.success){
            const list = res?.data.length > 0 ? res?.data.filter(acd => acd.status === "Active") : [];
            if(list.length > 0){
              dispatch(setAcademicYearList(list));

                const toLocalDateString = (date) => {
                  const d = new Date(date);
                  const year = d.getFullYear();
                  const month = String(d.getMonth() + 1).padStart(2, "0");
                  const day = String(d.getDate()).padStart(2, "0");
                  return `${year}-${month}-${day}`;
                };
                  const todayStr = toLocalDateString(new Date());

                  let current = list.find(session => {
                    const startStr = toLocalDateString(session.startDate);
                    const endStr = toLocalDateString(session.endDate);

                    return todayStr >= startStr && todayStr <= endStr;
                  });

                  if (!current && list.length > 0) {
                    current = [...list].sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )[0];
                  }

                // setSelectedOption(current);
                dispatch(setAcademicYear(current));

                const updatedStudentInfo = {
                  ...user,
                  schoolID: option.schoolID,
                  schoolName: option.schoolName,
                };
                dispatch(setSelectedSchool(option));
                dispatch(loginSuccess(updatedStudentInfo));
            } else{
              dispatch(setAcademicYearList([]));
              dispatch(setAcademicYear(null));

              const updatedStudentInfo = {
                ...user,
                schoolID: option.schoolID,
                schoolName: option.schoolName,
              };
      
              dispatch(setSelectedSchool(option));
              dispatch(loginSuccess(updatedStudentInfo));
            }
            return list
          } else{
            setIsLoading(false);
            return null;
          }
        } catch (error) {
          setIsLoading(false);
          return null;
        } finally {
          setSelectedOption(option);
          setIsLoading(false);
        }
      };

const handleSelect = async  (option) => {
  
  setIsOpen(false);
    const res = await fetchAcademicYearList(option.schoolID, option);
    const schoolRoutes = user?.schoolsRoutes?.find(school => school.schoolID === option.schoolID)?.routes || [];
    const schoolObject = user?.schoolList?.find(school => school.schoolID === option.schoolID) || {};
    const fallbackSchoolRoutes = user?.routes || [];
    const selectedSchoolRoutes = schoolRoutes.length > 0 ? schoolRoutes : fallbackSchoolRoutes;
    dispatch(loginSuccess({
        ...user,
        schoolID: schoolObject.schoolID,
        groupID: schoolObject.groupID,
        schoolName: schoolObject.schoolName,
        routes: selectedSchoolRoutes
    }));
    navigate(ROUTES.HOME);
};

useEffect(() => {
  if (schoolProfileData?.schoolID && selectedSchool) {
    setSchoolDropList(schoolList ?? []);
    setSelectedOption(selectedSchool);
  }
}, [schoolProfileData, user?.schoolID]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

// ✅ proper check
if (!selectedOption) return null;


  return (
    <Box ref={dropdownRef} className="school_nameheader">
      <Tooltip>
        <Box
          className="school_box"
          onClick={toggleDropdown}
          sx={{
            borderColor: theme.palette.custom.borderColor,
            cursor: schoolList.length > 1 ? 'pointer' : 'default',
            maxWidth: { xs: '100%', sm: 'auto' },
          }}
        >
          <img
            src={getFullImageUrl(selectedOption.schoolLogo) || schoolProfileLogo}
            alt={selectedOption.schoolName}
            // width="28"
            // height="28"
            style={{width:'auto',maxWidth:'90px',height:'auto',maxHeight:28}}
          />
          <Typography
            className="ellipse-text line-2"
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: theme.palette.background.text }}
            lineHeight={'18px'}
          >
            {selectedOption.schoolName} {selectedOption?.schoolBranchName ? ` - ${selectedOption?.schoolBranchName}` : ''}
          </Typography>
        </Box>
      </Tooltip>
      {isOpen && (
        <Box
          component="ul"
          className="school-dropdown-list"
          sx={{ overflow: 'hidden', backgroundColor: theme.palette.background.bgwhite }}
        >
          {schoolDropList.map((option, index) => (
            <Box
              component="li"
              key={index}
              onClick={() => handleSelect(option)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 20px!important',
                cursor: 'pointer',
                color: theme.palette.background.text,
                '&:hover': {
                  backgroundColor: theme.palette.custom?.listMenuhoverbg || '#f0f0f0',
                },
              }}
            >
              <img
                src={getFullImageUrl(option.schoolLogo) || schoolProfileLogo}
                alt={option.schoolName}
                width="24"
                height="24"
                style={{ marginRight: '8px' }}
              />
              <span>{option.schoolName} {option?.schoolBranchName ? ` - ${option?.schoolBranchName}` : ''}</span>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AllSchoolnameDropdown;
